import * as gfunctions from '../../../js/generalFunctions';

CCL.favorites = {
  autoload: [
    ['initialFavLoad', $('body').length > 0],
    ['favPageLoad', $('#favoritesPage').length > 0]
  ],

  favPageLoad() {
    if (window.favoritesSasData) {
      // SAS Event for favorite page load
      gfunctions.sasEvents('send', window.favoritesSasData);
    }
  },

  initialFavLoad() {
    // Add to Favorites
    $('body').on('click keypress', '.add-to-fav', (e) => {
      this.ajaxForFavorite(e, true);
    });

    // Remove from Favorites
    $('body').on('click keypress', '.remove-from-fav', (e) => {
      this.ajaxForFavorite(e, false);
    });

    // Remove from Favorites *FROM FAVORITE PAGE
    $('body').on('click keypress', '.remove-from-favorite', (e) => {
      this.ajaxForRemoveFromFavorite(e);
    });

    // Move to Favorites *FROM SAVE FOR LATER
    $('body').on('click keypress', '.move-to-favorites-from-cart', (e) => {
      this.ajaxForMoveToFavoriteFromCart(e);
    });
  },

  ajaxForMoveToFavoriteFromCart(event) {
    const { productid, baseproductid } = $(event.target)[0].dataset;

    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxUrl = `/shop/favorites/move/${productid}/${baseproductid}`;
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      const titleHtml = $(`#saveForLaterCartSection .card-${productid} .title`).html();
      $(`#saveForLaterCartSection .card-${productid}`).empty();
      $(`#saveForLaterCartSection .card-${productid}`).css('min-height', '100px');
      $(`#saveForLaterCartSection .card-${productid}`).html(`${titleHtml} has been moved to your Favorites.`).addClass('removed-card');

      if (response.wishListFull) {
        this.openFavFullModal();
      } else {
        const msg = `<span class="white-checkmark"></span>Added to favorites: <strong>${response.productName}</strong>`;
        gfunctions.showGlobalToast('#toastMessage', 4000, msg);
        gfunctions.updateHeaderFavoriteWidget(response);
        /* eslint-disable */
        ga('send', 'event', 'Add to Favorites', 'Add to Favorites', productid, 1);
        if (response.cclSasAnalyticsJsonData) {
          // SAS Event for favorite
          gfunctions.sasEvents('send', JSON.parse(response.cclSasAnalyticsJsonData));
        }
        /* eslint-enable */
      }
      gfunctions.hideLoader();
    }).fail(() => {
      console.log('error while remove from fav');
      gfunctions.hideLoader();
    });
  },

  ajaxForRemoveFromFavorite(event) {
    const { productid } = $(event.target)[0].dataset;

    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxUrl = `/shop/favorites/remove/${productid}`;
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      $('body').find(`.favorite-card-${productid}`).remove();
      $('body').find('.c-favorites-heading .favorites-page-title').html(`YOUR FAVORITES (${response.wishlistItemCount} ITEMS)`);
      gfunctions.updateHeaderFavoriteWidget(response);
      gfunctions.hideLoader();
      const msg = `<span class="white-checkmark"></span>Removed from favorites: <strong>${response.productName}</strong>`;
      gfunctions.showGlobalToast('#toastMessage', 4000, msg);
      /* eslint-disable */
      ga('send', 'event', 'Remove from Favorites', 'Remove from Favorites', productid, 1);
      if (response.cclSasAnalyticsJsonData) {
        // SAS Event for favorite
        gfunctions.sasEvents('send', JSON.parse(response.cclSasAnalyticsJsonData));
      }
      /* eslint-enable */
      if (response.wishlistItemCount === 0) {
        window.location.reload();
      }
    }).fail(() => {
      console.log('error while remove from fav');
      gfunctions.hideLoader();
    });
  },

  ajaxForFavorite(event, add = true) {
    const { usermode, productid } = $(event.target).parents('.fav-section').find('.add-to-fav')[0].dataset;
    // if its browe mode then redirect user to login
    if (usermode === 'BROWSE') {
      const refUrl = window.location.pathname + window.location.search;
      const alteredURL = gfunctions.removeParam('page', refUrl);
      const encodedURL = window.location.search === '' ? encodeURIComponent(`${alteredURL}?ref=favorite&productId=${productid}`) : encodeURIComponent(`${alteredURL}&ref=favorite&productId=${productid}`);
      console.log(refUrl, alteredURL);
      window.location.href = `/profilemanagement/accounts/login?returnUrl=${encodedURL}&eru=true`;
    } else {
      if (add === true) {
        $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
        $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
      } else {
        $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
        $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
      }

      let ajaxUrl = add === true ? `/shop/favorites/add/${productid}` : `/shop/favorites/remove/${productid}`;
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/json-data/favorite.json';
      }

      const token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'GET',
        url: ajaxUrl,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done((response) => {
        if (response.wishListFull) {
          this.openFavFullModal();
          if (add === true) {
            $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
            $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
          } else {
            $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
            $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
          }
        } else {
          /* eslint-disable */
          if (add === true) {
            ga('send', 'event', 'Add to Favorites', 'Add to Favorites', productid, 1);
          } else {
            ga('send', 'event', 'Remove from Favorites', 'Remove from Favorites', productid, 1);
          }
          /* eslint-enable */
          const msg = add === true ? `<span class="white-checkmark"></span>Added to favorites: <strong>${response.productName}</strong>` : `<span class="white-checkmark"></span>Removed from favorites: <strong>${response.productName}</strong>`;
          gfunctions.showGlobalToast('#toastMessage', 4000, msg);
          gfunctions.updateHeaderFavoriteWidget(response);
        }

        if (response.cclSasAnalyticsJsonData) {
          // SAS Event for favorite
          gfunctions.sasEvents('send', JSON.parse(response.cclSasAnalyticsJsonData));
        }
      }).fail(() => {
        console.log('error while adding to fav');
        gfunctions.hideLoader();
        if (add === true) {
          $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
          $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
        } else {
          $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
          $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
        }
      });
    }
  },

  openFavFullModal() {
    gfunctions.showModal('favFullModal');
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-favorites/c-favorites.js